import React, { useState, useEffect, useCallback } from 'react';
import { Button, Tooltip } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS, useUser } from '../../core/context/UserContext';
import AiChatPanel from './AiChatPanel';
import './ai-chat.css';

export default function AiChatButton() {
    const { t } = useTranslation();
    const { hasPermission } = useUser();
    const [panelVisible, setPanelVisible] = useState(false);

    // Permission kontrolü
    if (!hasPermission(PERMISSIONS.AI_CHAT)) {
        return null;
    }

    return (
        <>
            <Tooltip title={t('AI Asistan')} placement="left">
                <Button
                    type="primary"
                    shape="circle"
                    size="large"
                    icon={<RobotOutlined style={{ fontSize: 24 }} />}
                    className="ai-chat-floating-btn"
                    onClick={() => setPanelVisible(true)}
                />
            </Tooltip>
            <AiChatPanel
                visible={panelVisible}
                onClose={() => setPanelVisible(false)}
            />
        </>
    );
}
